import React, { useState } from 'react';
import {
  Shield, KeyRound, User, Settings, CloudOff, FileSpreadsheet, Mic2, MessageSquare,
  MessageCircle, Loader2, FileText,
} from 'lucide-react';
import { api, guestToken } from '../../lib/api';
import AdminAccess from './AdminAccess';
import AdminPersona from './AdminPersona';
import AdminSettings from './AdminSettings';
import AdminOffline from './AdminOffline';
import AdminImport from './AdminImport';
import AdminDiscours from './AdminDiscours';
import AdminConversations from './AdminConversations';
import AdminPrompt from './AdminPrompt';

export default function Admin(props) {
  const [tab, setTab] = useState('acces');
  const [opening, setOpening] = useState(false);
  const { setScreen, setUserAuthed } = props;

  // Ouvre Oliv'IA en tant qu'admin : session dédiée, sans code ni coupon,
  // et hors quotas — pour tester le persona à tout moment.
  const openOlivia = async () => {
    setOpening(true);
    try {
      const { token } = await api.post('/api/admin/preview_session');
      guestToken.set(token);
      setUserAuthed(true);
      setScreen('chat');
    } catch (e) {
      setOpening(false);
      window.alert(e.message || "Impossible d'ouvrir Oliv'IA.");
    }
  };

  return (
    <div className="page">
      <div className="admin-head">
        <h2 className="page-title"><Shield size={20} /> Administration</h2>
        <div className="admin-head-right">
          <button className="btn-primary" onClick={openOlivia} disabled={opening}>
            {opening ? <Loader2 size={16} className="spin" /> : <MessageCircle size={16} />} Ouvrir Oliv'IA
          </button>
          <span className="admin-pill">Connecté en administrateur</span>
        </div>
      </div>
      <div className="tabs">
        <button className={`tab${tab === 'acces' ? ' active' : ''}`} onClick={() => setTab('acces')}><KeyRound size={15} /> Accès & codes</button>
        <button className={`tab${tab === 'persona' ? ' active' : ''}`} onClick={() => setTab('persona')}><User size={15} /> Persona</button>
        <button className={`tab${tab === 'prompt' ? ' active' : ''}`} onClick={() => setTab('prompt')}><FileText size={15} /> Prompt</button>
        <button className={`tab${tab === 'discours' ? ' active' : ''}`} onClick={() => setTab('discours')}><Mic2 size={15} /> Discours</button>
        <button className={`tab${tab === 'historique' ? ' active' : ''}`} onClick={() => setTab('historique')}><MessageSquare size={15} /> Historique</button>
        <button className={`tab${tab === 'reglages' ? ' active' : ''}`} onClick={() => setTab('reglages')}><Settings size={15} /> Réglages & moteur</button>
        <button className={`tab${tab === 'offline' ? ' active' : ''}`} onClick={() => setTab('offline')}><CloudOff size={15} /> Hors ligne</button>
        <button className={`tab${tab === 'import' ? ' active' : ''}`} onClick={() => setTab('import')}><FileSpreadsheet size={15} /> Import</button>
      </div>
      {tab === 'acces' && <AdminAccess {...props} />}
      {tab === 'persona' && <AdminPersona {...props} />}
      {tab === 'prompt' && <AdminPrompt {...props} />}
      {tab === 'discours' && <AdminDiscours {...props} />}
      {tab === 'historique' && <AdminConversations {...props} />}
      {tab === 'reglages' && <AdminSettings {...props} />}
      {tab === 'offline' && <AdminOffline {...props} />}
      {tab === 'import' && <AdminImport {...props} />}
    </div>
  );
}
